module.exports = __webpack_public_path__ + "static/media/logo.afe9022e.png";